module.exports = __webpack_public_path__ + "db0080bb67d7fbcbc4fd97f4911361e6.svg";